var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputs"},[_vm._l((6),function(item,index){return _c('div',{key:index,class:['input-item',
  index==_vm.value.length?'input-item-active':'',
  _vm.value.length===6 && index===5?'input-item-active':'',
  _vm.value[index]?'input-placehoder':'']})}),_c('input',{ref:"input",staticClass:"input",attrs:{"inputmode":"numeric"},on:{"input":_vm.input}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }